import styled from 'styled-components'
import { INTER } from '@styles/fonts'
import { NEUTRAL_300 } from '@styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow: hidden;
  padding: 24px 16px;
`

export const PhoneInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const DropdownWrapper = styled.div`
  width: 100%;
`

export const KeyboardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: white;
  margin-top: auto;
`

export const AmountSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 16px;
  overflow: hidden;
`

export const AmountLabel = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${NEUTRAL_300};
  margin-bottom: 16px;
`

export const AmountGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  flex: 1;
  overflow-y: auto;
  padding-bottom: 16px;
`

export const ButtonWrapper = styled.div`
  padding-top: 16px;
  background-color: white;
`
